import { NextPage } from 'next'
import { useState } from 'react'
import { FaSearch } from 'react-icons/fa'
import InfiniteScroll from 'react-infinite-scroller'
import { ArticleList } from 'web_core/assets/article/List'
import { CategorySelector } from 'web_core/assets/category'
import { LoadingSpinner } from 'web_core/assets/spinners'
import { useQueryData } from 'web_core/hooks'
import { useESArticles } from 'web_core/hooks/models'
import { isBlank } from 'web_core/utils'
import { makeLocaleStaticProps } from 'web_core/utils/static_props'
import { DefaultLayout } from '~/components/Layout/Default'
import { Heading } from '~/components/Utils/Heading'
import { SearchNavSelector } from '~/components/Utils/SearchNavSelector'
import { useLayoutProperty } from '~/context/layout_property'
import { articleSearchBreadcrumb } from '~/utils'

export const getStaticProps = makeLocaleStaticProps

const Page: NextPage = () => {
  const keyword = useQueryData('keyword')
  const [categoryId, setCategoryId] = useState<string>()
  const { articles, loadMore, isReachingEnd, isLoadingMore } = useESArticles(
    !isBlank(keyword) && keyword !== ''
      ? {
          type: 'query',
          locale: 'ja',
          category_ids:
            !isBlank(categoryId) && categoryId !== ''
              ? [categoryId]
              : undefined,
          keyword,
          apply_recommendation: true,
          order: 'score desc',
        }
      : null
  )
  const title =
    !isBlank(keyword) && keyword !== ''
      ? `「${keyword}」に関連する記事`
      : '記事の検索'
  const description =
    !isBlank(keyword) && keyword !== ''
      ? `「${keyword}」に関連する記事の一覧を閲覧できます。`
      : `Mathlogの記事検索ページです。キーワードを入力して目的の記事を見つけましょう。`

  const { headerHeight } = useLayoutProperty()
  return (
    <DefaultLayout
      head={{ title, description, keyword: keyword ?? undefined }}
      navLinks={{ pc: true, tablet: true, sp: true }}
      categoriesMenu={{ pc: true }}
      leftSidebar
      rightSideBar
    >
      {articleSearchBreadcrumb.toReactNode()}
      <Heading title={title} icon={FaSearch} />
      <div
        className="sticky-top bg-white pt-2 pb-2 mb-2 mb-md-4"
        style={{ top: headerHeight }}
      >
        <SearchNavSelector
          active="articles"
          link="/[target]"
          keyword={keyword}
          className="mb-2 mb-md-4"
        />
        <CategorySelector
          className="fs-7"
          style={{ maxWidth: 300 }}
          value={categoryId}
          onChange={setCategoryId}
          undefinedLabel={'全てのカテゴリ'}
        />
      </div>
      {!isBlank(keyword) && keyword !== '' ? (
        <InfiniteScroll
          loadMore={async () => {
            if (
              isLoadingMore === false &&
              isReachingEnd === false &&
              isReachingEnd === false
            )
              await loadMore()
          }}
          hasMore={isReachingEnd === false}
          loader={<LoadingSpinner />}
        >
          {articles && (
            <ArticleList
              articles={articles}
              className="grid g-cols-1 g-lg-cols-2"
            />
          )}
        </InfiniteScroll>
      ) : (
        <p>検索キーワードを入力してください。</p>
      )}
    </DefaultLayout>
  )
}

export default Page
